/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Relationship } from '../model';
// @ts-ignore
import { RelationshipEvent } from '../model';
/**
 * RelationshipApi - axios parameter creator
 * @export
 */
export const RelationshipApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary creates a single relationship
         * @param {Relationship} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRelationship: async (data?: Relationship, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/relationships`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(data, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary enable/disable a single relationship
         * @param {number} id 
         * @param {boolean} enabled 
         * @param {number} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableRelationship: async (id: number, enabled: boolean, version?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('enableRelationship', 'id', id)
            // verify required parameter 'enabled' is not null or undefined
            assertParamExists('enableRelationship', 'enabled', enabled)
            const localVarPath = `/navigator/relationships/{id}/enabled/{enabled}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"enabled"}}`, encodeURIComponent(String(enabled)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary gets a single relationship
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationship: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRelationship', 'id', id)
            const localVarPath = `/navigator/relationships/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the relationships optionally by nodeId
         * @param {number} [nodeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationships: async (nodeId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/relationships`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary determines if a relationship exists
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasRelationship: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('hasRelationship', 'id', id)
            const localVarPath = `/navigator/entities/{id}/hasRelationship`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updates a single relationship
         * @param {number} id 
         * @param {Relationship} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelationship: async (id: number, data?: Relationship, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateRelationship', 'id', id)
            const localVarPath = `/navigator/relationships/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(data, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updates a single relationshipEvent
         * @param {number} id 
         * @param {RelationshipEvent} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelationshipEvent: async (id: number, data?: RelationshipEvent, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateRelationshipEvent', 'id', id)
            const localVarPath = `/navigator/relationshipEvents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(data, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RelationshipApi - functional programming interface
 * @export
 */
export const RelationshipApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RelationshipApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary creates a single relationship
         * @param {Relationship} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRelationship(data?: Relationship, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Relationship>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRelationship(data, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary enable/disable a single relationship
         * @param {number} id 
         * @param {boolean} enabled 
         * @param {number} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableRelationship(id: number, enabled: boolean, version?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Relationship>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableRelationship(id, enabled, version, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary gets a single relationship
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelationship(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Relationship>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelationship(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets the relationships optionally by nodeId
         * @param {number} [nodeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelationships(nodeId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Relationship>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelationships(nodeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary determines if a relationship exists
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hasRelationship(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hasRelationship(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updates a single relationship
         * @param {number} id 
         * @param {Relationship} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRelationship(id: number, data?: Relationship, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Relationship>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRelationship(id, data, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updates a single relationshipEvent
         * @param {number} id 
         * @param {RelationshipEvent} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRelationshipEvent(id: number, data?: RelationshipEvent, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelationshipEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRelationshipEvent(id, data, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RelationshipApi - factory interface
 * @export
 */
export const RelationshipApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RelationshipApiFp(configuration)
    return {
        /**
         * 
         * @summary creates a single relationship
         * @param {Relationship} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRelationship(data?: Relationship, options?: any): AxiosPromise<Relationship> {
            return localVarFp.createRelationship(data, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary enable/disable a single relationship
         * @param {number} id 
         * @param {boolean} enabled 
         * @param {number} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableRelationship(id: number, enabled: boolean, version?: number, options?: any): AxiosPromise<Relationship> {
            return localVarFp.enableRelationship(id, enabled, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary gets a single relationship
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationship(id: number, options?: any): AxiosPromise<Relationship> {
            return localVarFp.getRelationship(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the relationships optionally by nodeId
         * @param {number} [nodeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationships(nodeId?: number, options?: any): AxiosPromise<Array<Relationship>> {
            return localVarFp.getRelationships(nodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary determines if a relationship exists
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasRelationship(id: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.hasRelationship(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updates a single relationship
         * @param {number} id 
         * @param {Relationship} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelationship(id: number, data?: Relationship, options?: any): AxiosPromise<Relationship> {
            return localVarFp.updateRelationship(id, data, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updates a single relationshipEvent
         * @param {number} id 
         * @param {RelationshipEvent} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelationshipEvent(id: number, data?: RelationshipEvent, options?: any): AxiosPromise<RelationshipEvent> {
            return localVarFp.updateRelationshipEvent(id, data, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RelationshipApi - object-oriented interface
 * @export
 * @class RelationshipApi
 * @extends {BaseAPI}
 */
export class RelationshipApi extends BaseAPI {
    /**
     * 
     * @summary creates a single relationship
     * @param {Relationship} [data] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipApi
     */
    public createRelationship(data?: Relationship, options?: any) {
        return RelationshipApiFp(this.configuration).createRelationship(data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary enable/disable a single relationship
     * @param {number} id 
     * @param {boolean} enabled 
     * @param {number} [version] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipApi
     */
    public enableRelationship(id: number, enabled: boolean, version?: number, options?: any) {
        return RelationshipApiFp(this.configuration).enableRelationship(id, enabled, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary gets a single relationship
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipApi
     */
    public getRelationship(id: number, options?: any) {
        return RelationshipApiFp(this.configuration).getRelationship(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the relationships optionally by nodeId
     * @param {number} [nodeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipApi
     */
    public getRelationships(nodeId?: number, options?: any) {
        return RelationshipApiFp(this.configuration).getRelationships(nodeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary determines if a relationship exists
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipApi
     */
    public hasRelationship(id: number, options?: any) {
        return RelationshipApiFp(this.configuration).hasRelationship(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updates a single relationship
     * @param {number} id 
     * @param {Relationship} [data] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipApi
     */
    public updateRelationship(id: number, data?: Relationship, options?: any) {
        return RelationshipApiFp(this.configuration).updateRelationship(id, data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updates a single relationshipEvent
     * @param {number} id 
     * @param {RelationshipEvent} [data] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipApi
     */
    public updateRelationshipEvent(id: number, data?: RelationshipEvent, options?: any) {
        return RelationshipApiFp(this.configuration).updateRelationshipEvent(id, data, options).then((request) => request(this.axios, this.basePath));
    }
}
